var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3578",
    "data-name": "Group 3578",
    transform: "translate(-264 -355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(264 355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579",
    transform: "translate(0.221 1.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577",
    transform: "translate(272.651 360.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M1.173,2.347h0A1.173,1.173,0,1,1,2.347,1.174,1.177,1.177,0,0,1,1.173,2.347",
    transform: "translate(0 14.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M9.909,4.874A4.929,4.929,0,0,0,4.954,0h0A4.929,4.929,0,0,0,0,4.874V12S9.908,10.91,9.909,4.874h0",
    transform: "translate(2.347)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastMessage);
export default __webpack_public_path__ + "static/media/toast-message.7e8dc09e8de711b8eae7d6fa73ff5b10.svg";
export { ForwardRef as ReactComponent };